/**
 * @typedef {Object} IsDataType
 * @property {string} name - Download action title
 *
 * @typedef {Object} SpecialReportAvailabletypes
 * @property {IsDataType} isCsv - Csv Download button available
 * @property {IsDataType} isHtml - Html view available
 * @property {IsDataType} isPdf - Pdf download button available
 */

/**
 * Returns view and export options available for the special report
 *
 * @return {SpecialReportAvailabletypes}
 */
const getSpecialReportTypes = () => {
    const typesStorage = sessionStorage.getItem("typesSpecial") || null;
    const types = typesStorage ? JSON.parse(typesStorage) : [];
    const isCsv = types.find((type) => type["content-type"] === "csv");
    const isHtml = types.find((type) => type["content-type"] === "html");
    const isPdf = types.find((type) => type["content-type"] === "pdf");
    const isXlsx = types.find((type) => type["content-type"] === "xlsx");

    return { isCsv, isHtml, isPdf, isXlsx };
};

export { getSpecialReportTypes };
